export default __webpack_public_path__ + "img/upgrade_bg_1-b631bd89671613406cbd7505f545dbf3.png";